import type { Data } from '../../core/components/overlay-tooltip/types.js';
import { safeGet } from '../../core/utils/safe-get.js';
import type { HoneycombTooltipMetadata } from '../types/honeycomb-internal.js';
import type { HoneycombTileData } from '../types/honeycomb.js';

export const buildOverlayTooltipData = (
  tileIndex: number,
  honeycombData: HoneycombTileData[],
  tooltipMetadata: WeakMap<HoneycombTileData, HoneycombTooltipMetadata>,
): Data => {
  const tileData = honeycombData[tileIndex];
  const metadata = safeGet(tooltipMetadata, tileData);
  return {
    geometry: 'honeycomb',
    header1: [],
    metadata: { id: metadata.id },
    series: [
      {
        name: metadata.name,
        color: metadata.color.Default,
        value: metadata.value.toString(),
      },
    ],
  };
};
